import { c as _c } from "react/compiler-runtime";
import type { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';
export interface CardProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  titleBar?: ReactNode;
}
export function Card(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let titleBar;
  if ($[0] !== t0) {
    ({
      className,
      children,
      titleBar,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = titleBar;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    titleBar = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("card bg-base-100 shadow-sm rounded-2xl", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== children) {
    t2 = <div className="card-body">{children}</div>;
    $[7] = children;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== props || $[10] !== t1 || $[11] !== t2 || $[12] !== titleBar) {
    t3 = <div className={t1} {...props}>{titleBar}{t2}</div>;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
    $[12] = titleBar;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}